import React from 'react';
import styles from './AdminMoblieUserList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH3FontSize } from '../constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';

const AdminMoblieUserList = ({users}) => {
    if (!users || users.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {users && users.map((user, index) => (
                <FlexChild key={index} height="initial">
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap="0.5rem">
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <P size={pageEH3FontSize}>{user.userName}</P>
                                        <P size={pageEH3FontSize}>&nbsp;({user.userId})</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end" width="auto">
                                        <div className={styles.statusBox}>
                                            <P size={pageEH3FontSize}>
                                                {user.userStatus === "admin" && "본사"}
                                                {user.userStatus === "clerk" && "점원"}
                                                {user.userStatus === "vendor" && "점주"}
                                            </P>
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild alignItems="flex-start">
                                <P size={pageEH3FontSize}>
                                    지점: {user.userAffiliation}
                                </P>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap="1rem">
                                    <FlexChild>
                                        <div className={styles.modifyBtn}>
                                            <P size={pageEH3FontSize}>수정</P>
                                        </div>
                                    </FlexChild>
                                    <FlexChild>
                                        <div className={styles.deleteBtn}>
                                            <P size={pageEH3FontSize}>삭제</P>
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            ))}
        </VerticalFlex>
    );
};

export default AdminMoblieUserList;